<template>
  <div
    :class="[!listView ? 'products-list__tiles' : 'products-list__list']"
  >
    <div
      v-for="(element, index) in productsList"
      :key="index"
      :class="[!listView ? `products-list__tiles__element products-list__tiles__element--type_${element.type}` : `products-list__list__element--type_${element.type}`]"
    >
      <template v-if="element.type === 'product'">
        <product-box
          class="products-list__product-box"
          v-bind="element.data"
          :index="index"
          :list-view="listView"
          :itemgroupid="element.data.id"
          :item-id="element.data.itemId"
        />
      </template>
      <template v-else-if="element.type === 'insertion'">
        <slot
          :name="`slot-insertion-${element.data.id}`"
        />
        <template-compiler
          :template="getTeaser(`insertion-${element.data.id}`)"
        />
      </template>
    </div>
  </div>
</template>

<script>
import ProductBox from '../productBox/productBox.vue'
import TemplateCompiler from '../templateCompiler/templateCompiler.vue'

export default {
  components: {
    ProductBox,
    TemplateCompiler
  },
  props: {
    productsList: Array,
  },
  mounted() {
    let articlesPerRow = this.$store.getters['productsListPage/articlesPerRow']
    this.listView = articlesPerRow !== 3
  },
  methods: {
    getTeaser(id) {
      const insertion = this.$store.getters['productsListPage/insertion'](id)
      if (insertion !== undefined) {
        return insertion.data
      }
    }
  },
  data() {
    return {
      teaserIndex: 0,
      listView: false
    }
  }
}

</script>
